// extracted by mini-css-extract-plugin
export default {"page":"qY-z","cartModal":"rY-z","checkout":"sY-z","placeholder":"tY-z","account":"uY-z"};